export const GROUP_NAME = 'input-radio'

export enum Variants {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
}

export const DEFAULT_VARIANT = Variants.Primary
